import { Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Payments from "./pages/Payments";
import Unauthorized from "./pages/Unauthorized";
import Missing from "./pages/Missing";
import RequireAuth from "./components/Auth/RequireAuth";
import { ROLES } from "./ts/enums/roles";
import PersistLogin from "./components/Auth/PersistLogin";
import RouteSelection from "./pages/RouteSelection";

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />

      {/*This Login route should probably be removed and make the app re route for / to /login */}
      <Route path="/" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* private */}
      <Route element={<PersistLogin />}>
        <Route element={<RequireAuth allowedRoles={[ROLES.ADMIN]} />}>
          {" "}
          <Route path="/:routeId" element={<Dashboard />} />
          <Route path="/route-select" element={<RouteSelection />} />
          <Route path="/payments" element={<Payments />} />
        </Route>
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Missing />} />
    </Routes>
  );
}
